module.exports = __webpack_public_path__ + "img/11_no.9fdf23be.svg";